import axios from 'axios';

const isDev = process.env.NODE_ENV === 'development';

const defaultBaseURL = isDev
    ? 'http://localhost:8080'
    : '/api';

const apiClient = axios.create({
    baseURL: defaultBaseURL,
    withCredentials: true,
});

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn('Sesión caducada o inválida. Redirigiendo al login...');
            localStorage.removeItem('user');

            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
)

export default apiClient;
